<template>
  <div class="wayline-editor" style="height:100%;width:100%;position: relative;">
    <!-- <template>
      <div class="import-container">

        <template v-if="actionType == 'create' || actionType == 'edit'">
          <el-button class="btn" type="primary" size="mini" @click="importClick" v-has="'fcs:route:add'">
            <img class="btn-img" src="../main/imgs/download-2-line.png" />
            {{ $t('route.airline.importRoute') }}
          </el-button>

        </template>
</div>
</template> -->

    <MainLayout ref="mainLayout" :hasLeft="false" :rightWidth="400">
      <News slot="header" :hasBack="true" :useDefaulGoBack="false" @goBack="goBack"></News>
      <div slot="main" style="position: relative;height:100%;width:100%; padding:5px">
        <MapContainer ref="mapContainer" :zoomToolConfig="zoomToolConfig" :bottomToolConfig="bottomToolConfig">
          <template slot="openlayer">
            <OpenlayerGridLayer :zIndex="199" :gridList="gridList" :popoverDisabled="true">
            </OpenlayerGridLayer>
            <HivesPoints :hives="siteList" :hivesTopShow="false"></HivesPoints>
            <!-- <Airline type='route' :routeObj="routeObj" :airlineConfig="waylineConfig" :hives="siteList"
            :toXmlFile="() => { }">
          </Airline> -->
            <OlWaylineLayer v-if="!loading" :waylineConfig="waylineConfig"
              :editable="!isGridWay && actionType != 'detail'">
            </OlWaylineLayer>

          </template>
        </MapContainer>
      </div>
      <div slot="right" class="wayline-editor__right">
        <WaylineSetting ref="waylineSetting" :waylineInfo="waylineInfo" @cancel="cancelClick" @save="saveClick"
          @sekectDockChange="handleSelectDockChange" :editable="waylineSettingEditable" :saveLoading="saveLoading">
        </WaylineSetting>
      </div>
    </MainLayout>
  </div>
</template>

<script>
import MainLayout from '@/components/layout'
import News from '@/page/mainPage/components/news/News.vue';
import MapContainer from '@/components/map/MapContainer/MapContainer.vue';
import OpenlayerGridLayer from "@/page/business/chengguan/components/OpenlayerGridLayer"
import GridApi from '@/api/grid';
import DockApi from '@/api/flight/dock';
import RouteApi from '../main/api';
import * as MapUtils from '@/components/map/utils/index.js'
import { base64ToBlob, getNowTime } from "@/utils/common.js";

// import Airline from '../main/Airline.vue';
import OlWaylineLayer from './components/Map/OlWaylineLayer.vue';

import WaylineSetting from './components/WaylineSetting'
import WaypointListPanel from './components/WaypointListPanel'
import HivesPoints from '@/page/mainPage/mapComponents/HivesPoints.vue';
import { WaylineTemplateType, HeightModes } from '../constant/constant';
import WaylineUtil from "../util/WaylineUtil"

export default {
  components: {
    MainLayout,
    News,
    MapContainer,
    OpenlayerGridLayer,
    // Airline,
    WaylineSetting,
    WaypointListPanel,
    HivesPoints,
    OlWaylineLayer,

  },
  props: {},

  data() {
    return {
      loading: true,//航线加载状态
      saveLoading: false,//右侧保存按钮加载状态
      zoomToolConfig: {
        showViewMode: false,
      },
      bottomToolConfig: {
        showFly: false
      },
      actionType: "edit",// 操作类型，用于区分是新增还是编辑,create,edit,detail
      siteList: [],//机库站点列表
      routeId: "",//航线id
      gridGroupId: "",//网格组id
      gridId: "",//网格id
      gridInfo: null,//网格详情信息
      /**
       *  航线详情信息
       * coordinates 是格式为coordinates =  {
       *    routePoints: {
       *          ...this.waylineInfo.config,
       *    },
       *  }的对象经过JSON.stringify(coordinates)转换后的字符串
       * config 航线配置信息，这里是为了方便配置，所以这里不直接使用waylineInfo.coordinates
       * config 不保存到数据库中，只在前端使用，为了兼容旧版的航线数据，实际保存到数据库的是coordinates字段
       */

      waylineInfo: {
        name: "",//航线名称
        type: "LineString",//航线类型
        coordinates: "",
        distance: 0,//航线长度km
        estimateTime: 0,//预计飞行时间min
        siteId: "",//站点id
        flyMode: 1,//模式，0:人工，1:机库
        // jumpSiteId: "",
        jumpLocation: "",
        gridId: "",
        image: "",
        counts: 0,//航线点数
        remark: "",//备注
        status: 0,
        config: {
          type: "LineString",
          finishedAction: 'GO_HOME',//航线完成动作，GO_HOME：自动返航
          headingMode: 'FIXED',//机头方向，保持正北
          latlng: [],//参考起飞点
          speed: 10,//全局航线飞行速度m/s
          altitude: 118,//全局航线高度m
          // space: 20,//航线间隔m,多边形航线才有
          // sidelapSpacing: 20,//旁向航线间隔m，多边形航线才有
          // forwardSpacing: 100,//航向航线间隔m，多边形航线才有
          returnFlight: 110,//全局返航高度m
          gsdWide: 5,//GSD广角cm/pixel
          droneEnumValue: 67,//飞行器主型号枚举值，默认67是M30
          camera: 53,//相机型号,默认53 是M30T
          gsdInfrared: 18.55,//GSD红外cm/pixel
          cameraLens: ['wide'],//选择的相机镜头，wide广角,infrared 红外
          sidelap: 70,//旁向重叠率%
          course: 80,//航向重叠率%
          points: [],
          regions: [],
          photos: 0,//预计拍摄照片数
          polygonArea: 0,//预计覆盖面积km²
          flyMode: 1,//模式，1:孤岛模式，1:跳飞模式
          heightMode: HeightModes.relativeToStartPoint.value,//高度模式，relativeToStartPoint:相对起飞点,aboveGroundLevel:相对地形高度"
          imageFormat: 'visable'//存储照片类型，默认是可见光照片
        }
      },
      waylineSettingEditable: false,//航线设置是否可编辑,在请求到航线详情后，再设置为true，这样避免waylineSetting组件一开始就是editable状态而触发航点等计算而导致不必要的计算和回显之前的设置错误

      routeObj: {
        lineType: "LineString",
        searchHive: {},
        SeeShow: true,
        airT: 0,
        CurrentVal: {},
        rightShow: false,
        importState: false,
        altitudeLayers: {},
      }




    };
  },
  computed: {

    /**
       * 判断是否为网格航线
       *
       * @returns {boolean} 如果为网格方式，返回 true；否则返回 false
       */
    isGridWay() {
      let flag = false
      if (this.waylineInfo) {
        flag = !!this.waylineInfo.gridId
      }
      return flag
    },

    gridList() {
      let list = []
      if (this.gridInfo) {
        list.push(this.gridInfo)
      }
      return list
    },
    waylineConfig() {
      return this.waylineInfo.config || {}
    },



  },
  methods: {
    goBack() {
      this.$router.push("/route")

    },
    /**
     * 获取路由查询参数
     *
     * 从路由中获取参数和查询参数，并赋值给组件的实例变量
     */
    initQuery() {
      const params = this.$route.params;
      const query = this.$route.query;
      if (params) {
        const { actionType, routeId } = params
        this.actionType = actionType;
        this.routeId = routeId;
      }
      if (query) {
        const { gridGroupId, gridId } = query
        this.gridGroupId = gridGroupId;
        this.gridId = gridId;
      }

    },
    /**
     * 获取机库站点列表
     */
    getDockSiteList() {
      DockApi.fetchSiteList().then((res) => {

        let list = []
        if (res.code === 200) {
          list = res.rows || []
        }
        this.siteList = list;
        if (list.length > 0) {
          //当新建航线的时候，根据选择的站点，设置参考起飞点坐标
          const siteId = this.waylineInfo.siteId
          if (this.waylineInfo.siteId) {
            let latlng = this.waylineInfo.config.latlng
            if (!latlng || latlng.length === 0) {
              let site = list.find(item => item.id == siteId)
              if (site) {
                const { longitude, latitude } = site
                this.waylineInfo.config.latlng = [Number(longitude), Number(latitude)]
                setTimeout(() => {
                  this.handleSelectDockChange(site)
                }, 100);

              }

            }
          }

        }
      });
    },
    /**
     * 获取网格信息
     */
    async getGridInfo() {
      const self = this
      return new Promise((resolve, reject) => {
        if (self.gridId) {
          GridApi.fetchGridInfo(self.gridId).then((res) => {

            if (res.code === 200) {
              self.gridInfo = res.data

            }
            self.$nextTick(() => {
              self.fitGridExtent()
            })
            resolve(res)
          });
        }
      })

    },
    /**
     * 获取路线信息
     *
     * @returns 返回一个Promise对象，解析后得到路线信息的结果
     */
    async getRouteInfo() {
      const self = this
      return new Promise((resolve, reject) => {
        if (self.routeId) {
          RouteApi.getRouteInfo(self.routeId).then((res) => {

            let routeInfo = null
            if (res.code === 200) {
              routeInfo = res.data || null
            }
            resolve(routeInfo)
          });
        }
      })
    },
    /**
     * 调整地图视图以适应网格范围
     */
    fitGridExtent() {
      if (this.gridInfo) {
        const geometryText = this.gridInfo.geometryText
        const extent = MapUtils.getWktExtent(geometryText)
        if (extent) {
          if (this.$refs.mapContainer) {
            setTimeout(() => {
              this.$refs.mapContainer.fitExtent(extent, { padding: [40, 40, 40, 40] })
            }, 100);

          }
        }
      }
    },



    /**
     * 保存点击事件处理函数
     *
     * 根据actionType的值执行相应的操作
     *
     * 如果actionType为'create'，则创建一个新的路线，并调用RouteApi.getRouteAdd方法将路线信息提交到服务器
     *
     * @returns 无返回值
     */
    saveClick() {

      if (this.saveLoading) return

      let coordinates = {
        routePoints: {
          ...this.waylineConfig,
        },
      };
      if (this.gridId) {
        coordinates.routePoints.isGridWay = true

      }
      let param = {
        ...this.waylineInfo
      }
      param.coordinates = JSON.stringify(coordinates)
      delete param.config
      this.saveLoading = true
      setTimeout(() => {
        //5秒后关闭loading状态
        this.saveLoading = false

      }, 1000 * 5);

      this.uploadScreeshot().then((ossId) => {
        param.image = ossId
        if (this.actionType === 'create') {
          RouteApi.getRouteAdd(param).then(res => {
            this.saveLoading = false
            if (res.code === 200) {
              this.$message({
                message: this.$t('common.operationSuccess'),
                type: 'success',
              });
              const routeId = res.data
              if (routeId && typeof routeId == 'string') {
                this.$router.push({
                  path: `/route/edit/${routeId}`,
                })
              }
            }
          })
        } else if (this.actionType === 'edit') {
          RouteApi.getRouteEdit(param).then(res => {
            this.saveLoading = false
            if (res.code === 200) {
              this.$message({
                message: this.$t('common.operationSuccess'),
                type: 'success',
              });
            }
          })
        }
      })

    },


    /**
       * 上传截图
       *
       * @returns {Promise<string>} 返回一个Promise对象，Promise对象解析值为上传后的ossId，如果失败则返回空字符串
       */
    uploadScreeshot() {
      return new Promise((resolve, reject) => {
        if (this.$refs.mapContainer) {
          this.$refs.mapContainer.toDataURL().then((dataURL) => {

            let ossid = ""
            if (dataURL) {
              let base64Blob = base64ToBlob(dataURL);
              let fileObj = new File([base64Blob], `route${getNowTime()}.png`, {
                type: base64Blob.type,
              }); // 将Blob对象转换为File对象
              let formData = new FormData();
              formData.append('file', fileObj);


              RouteApi.setUpload(formData).then(res => {
                // console.log('res', res);
                if (res.code === 200) {
                  ossid = res.data.ossId
                }
                resolve(ossid)
              })

            } else {
              resolve(ossid)
            }

          })
        } else {
          resolve("")
        }
      })

    },
    /**
     * 初始化网格
     */
    initGrid() {
      if (this.gridId) {
        this.getGridInfo().then(() => {
          if (this.actionType === 'create') {
            this.waylineInfo.name = this.gridInfo.name
            this.waylineInfo.config.altitude = 118
            this.waylineInfo.config.sidelap = 20//旁向重叠率%
            this.waylineInfo.config.course = 25//航向重叠率%
            this.waylineInfo.config.isGridWay = true
            this.waylineInfo.config.regions = this.getGridRegions()
            this.waylineInfo.gridId = this.gridId
            this.waylineInfo.gridGroupId = this.gridInfo.gridGroupId
            this.waylineSettingEditable = true
            this.generateWaypoints()
            this.loading = false
          } else if (this.actionType === 'edit') {
            let waylineConfig = this.waylineInfo.config || {}
            let regions = waylineConfig.regions
            if (!regions) {
              this.waylineInfo.config.regions = this.getGridRegions()

            }
          }

        })
      }
    },
    getGridRegions() {
      let regions = []
      if (this.gridInfo) {
        let geometryText = this.gridInfo.geometryText
        if (geometryText) {
          let coordinates = MapUtils.getCoordinatesFromWKT(geometryText)
          // console.log('coordinates', coordinates)
          if (coordinates) {
            regions = WaylineUtil.coordinatesToRegions(coordinates)


          }
        }
      }
      // console.log(regions, 'regions')
      return regions
    },
    /**
     * 初始航线信息
     *
     * @description 根据动作类型和路由ID获取路由信息，若动作类型不为创建且存在路由ID，则调用 getRouteInfo 方法获取路由信息并打印。
     */
    initWaylineInfo() {
      if (this.actionType == 'create') {
        //当前动作类型为"新建航线时"
        if (this.gridId) {
          //如果是网格,初始化网格基本航线
          this.initGrid()
        } else {
          //如果不是网格，从路由查询参数中获取航线信息，并赋值给waylineInfo对象。
          const query = this.$route.query || {}
          const { name, type, siteId } = query
          let cloneWaylineInfo = JSON.parse(JSON.stringify(this.waylineInfo))
          cloneWaylineInfo.name = name
          if (type) {
            cloneWaylineInfo.type = type
            cloneWaylineInfo.config.type = type
          }
          if (type == WaylineTemplateType.polygon) {
            //旁向航线间隔m，多边形航线才有
            //航向航线间隔m，多边形航线才有
            cloneWaylineInfo.config.sidelapSpacing = 100
            //航向航线间隔m，多边形航线才有
            cloneWaylineInfo.config.forwardSpacing = 100
          }
          if (siteId) {
            cloneWaylineInfo.siteId = siteId

          }
          this.waylineInfo = cloneWaylineInfo

          this.routeObj.lineType = cloneWaylineInfo.type
          this.routeObj.SeeShow = false
          this.loading = false
        }
        setTimeout(() => {
          this.waylineSettingEditable = true
        }, 200);
      } else {
        //当前动作类型不是"新建航线时"，且有航线ID,查询航线信息
        if (this.routeId) {
          this.getRouteInfo().then((waylineInfo) => {

            if (waylineInfo) {
              let cloneWaylineInfo = JSON.parse(JSON.stringify(waylineInfo))
              let coordinates = waylineInfo.coordinates
              let waylineConfig = {}
              if (coordinates && typeof coordinates === 'string') {
                const coordinatesObj = JSON.parse(coordinates)
                waylineConfig = coordinatesObj.routePoints

              }
              cloneWaylineInfo.config = waylineConfig
              if (!waylineConfig.cameraLens) {
                waylineConfig.cameraLens = ["wide"]
              }
              delete cloneWaylineInfo['coordinates']
              this.waylineInfo = cloneWaylineInfo
              if (waylineConfig.isGridWay) {
                this.routeObj.SeeShow = true
              } else {
                if (this.actionType === 'edit') {
                  this.routeObj.SeeShow = false
                }
              }
              this.loading = false

            }
            this.initGrid()
            setTimeout(() => {
              this.waylineSettingEditable = true
            }, 200);
          })
        }



      }

    },
    cancelClick() {
      if (this.$refs.mainLayout) {
        this.$refs.mainLayout.toggleRight(false)
      }
    },
    generateWaypoints() {
      if (this.$refs.waylineSetting) {
        this.$refs.waylineSetting.generateWaypoints()
      }
    },
    /**
     * 处理右侧选择机库站点选择变化事件，定位到地图位置
     *
     * @param data 机库站点信息
     */
    handleSelectDockChange(data) {
      if (data) {
        const { longitude, latitude } = data
        if (longitude && latitude) {
          if (this.$refs.mapContainer) {
            this.$refs.mapContainer.toCenter([longitude, latitude])
          }
        }

      }
    },
    refreshData() {
      this.initQuery();
      this.initWaylineInfo()
    }
  },
  created() {
    this.initQuery();
    this.getDockSiteList();

  },
  mounted() {

    this.initWaylineInfo()

    this.$nextTick(() => {
      if (this.$refs.mainLayout) {
        this.$refs.mainLayout.toggleRight(true)
      }
    })
  },
  watch: {
    '$route.params': {
      handler(newParams, oldParams) {
        console.log(newParams, oldParams)
        if (newParams && oldParams) {
          const { actionType, routeId } = newParams
          if (actionType !== oldParams.actionType || routeId !== oldParams.routeId) {
            this.refreshData()
          }
        }

      },
      deep: false,
      immediate: true,
    },
  }
};
</script>


<style lang="scss" scoped>
.wayline-editor {
  &__right {
    height: calc(100% - 4px);
    position: relative;
    padding: 2px 0px;

  }

  .import-container {
    position: absolute;
    left: 16px;
    top: 80px;
    z-index: 1000;

    .btn {
      width: 110px;
      height: 37px;
      line-height: 22px;
      background: #49f0fd;
      border-radius: 2px 2px 2px 2px;
      border: 1px #49f0fd solid;
      color: #000000;
      overflow: hidden;
      font-size: 14px;

      .btn-img {
        float: left;
        margin-top: 2px;
      }
    }
  }
}

.select-mask {
  color: white;
  padding: 3px 3px 0 3px;

  background: rgba(7, 17, 80, 0.75) url(../imgs/select-mask.png) no-repeat;
  background-size: 100% 100%;
  border: 0;
  text-align: center;
  overflow: hidden;
  border-radius: 4px 4px 0 0;
  box-shadow: none;

  .el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover,
  .el-cascader-node:hover {
    background: linear-gradient(270deg,
        rgba(73, 240, 253, 0) 0%,
        rgba(73, 240, 253, 0.4) 32%,
        rgba(73, 240, 253, 0.4) 66%,
        rgba(73, 240, 253, 0) 100%);
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
  }

  .el-select-dropdown__item,
  .el-cascader-node {
    color: white;
    border-bottom: 1px rgba(73, 240, 253, 0.5) dashed;
  }

  .el-select-dropdown__item:last-child {
    border-bottom: 0;
  }
}
</style>